export const realDateFormat = (dateISO) => {
    const realData = dateISO.split("T")[0].split("-").reverse().join("/")
    return realData
}